<template>
  <div>
    <!-- 办理离职 -->
    <Modal v-model="leaveModal" title="办理离职">
      <Form ref="leaveStatus" :model="leaveStatus" :rules="this.rulesData" :label-width="120">
        <FormItem label="选择离职时间：" prop="leaveTime">
          <DatePicker
            v-model="leaveStatus.leaveTime"
            format="yyyy年MM月dd日"
            type="date"
            style="width: 200px;"
            :options="options"
          ></DatePicker>
        </FormItem>
        <FormItem prop="transferId">
          <Checkbox
            style="position: absolute;top:0;left:-115px;"
            v-model="leaveStatus.isTransfer"
            disabled
          >是否离职交接：</Checkbox>
          <div style="width: 200px;" v-show="leaveStatus.isTransfer">
            <selectPeople
              @byEmployee="getEmployeeAdd"
              ref="employees"
              :disableEmployee="disableEmployee"
            ></selectPeople>
          </div>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="leaveCancel">取消</Button>
        <Button type="primary" @click="leaveOk">确定</Button>
      </div>
    </Modal>

    <Drawer
      :title="modifyEmployeeDrawerTitle"
      v-model="modifyEmployeeDrawerStatus"
      width="720"
      :mask-closable="false"
      :styles="modifyEmployeeDrawerStyles"
      :closable="false"
    >
      <addForm-com
        :employeeInfo="employee"
        @closed-modify-employee-drawer="closedModifyEmployeeDrawer"
        @reset-employees-table="resetEmployeesTable"
      ></addForm-com>
    </Drawer>
  </div>
</template>

<script>
import Vuex from "vuex";
import addForm from "./EmployeeForm";
import selectPeople from "@/components/business/selectEmployee/selectEmployee.vue";

import { leaveStatus, initEmployeeForm } from "../constant";

export default {
  components: {
    "addForm-com": addForm,
    selectPeople: selectPeople
  },

  data() {
    return {
      //离职
      leaveModal: false,
      leaveStatus: JSON.parse(JSON.stringify(leaveStatus)),

      employee: JSON.parse(JSON.stringify(initEmployeeForm)),

      modifyEmployeeDrawerStatus: false,

      modifyEmployeeDrawerTitle: "添加人员",

      modifyEmployeeDrawerStyles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },

      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      }
    };
  },

  computed: {
    ...Vuex.mapState({
      rulesData: state => state.verify.rulesData
    }),
    //禁选的交接人员id
    disableEmployee() {
      var arr = [];
      arr[0] = this.leaveStatus.leverId;
      return arr;
    }
  },

  methods: {
    // 新增雇员
    getRefData() {
      this.resetEmployeesTable();
    },

    closedModifyEmployeeDrawer() {
      this.modifyEmployeeDrawerStatus = false;
    },

    resetEmployeesTable() {
      this.$parent.resetDepartmentEmployees();
    },

    leaveOk() {
      this.$refs.leaveStatus.validate(valid => {
        if (valid) {
          this.$api.employeeLeave(this.leaveStatus).then(() => {
            this.$Message.success("已提交！");
            this.leaveModal = false;
            this.handlerClear();
            this.resetEmployeesTable();
          });
        } else {
          this.$Message.error("请选择交接人");
        }
      });
    },
    handlerClear() {
      this.leaveStatus = JSON.parse(JSON.stringify(leaveStatus));
      this.$refs.employees.handlerClean();
    },
    // 离职交接
    getEmployeeAdd(val) {
      this.leaveStatus.transferId = val.map(item => {
        return item.id;
      })[0];
    },

    // 移除企业
    outOfEnterprise(employeeInfo) {
      this.$Modal.confirm({
        title: "确定要将该人员移出团队吗？",
        onOk: () => {
          this.$api
            .deleteEmployee({
              id: employeeInfo.id
            })
            .then(() => {
              this.$Message.success("已成功移除团队！");
              this.resetEmployeesTable();
            });
        }
      });
    },

    // 删除未激活的雇员
    deleteUnactivatedEmployee(employeeInfo) {
      this.$Modal.confirm({
        title: "确定要将该人员删除吗？",
        onOk: () => {
          this.$api
            .deleteEmployee({
              id: employeeInfo.id
            })
            .then(() => {
              this.$Message.success("删除成功！");
              this.resetEmployeesTable();
            });
        }
      });
    },

    // 拒绝申请加入
    refuseJoinEnterprise(employeeInfo) {
      this.$Modal.confirm({
        title: "拒绝加入",
        content:
          "<p>您确定拒绝 &nbsp;&nbsp;&nbsp;" +
          employeeInfo.employeeName +
          "&nbsp;&nbsp;&nbsp;的加入吗？",
        onOk: () => {
          var params = {
            id: employeeInfo.id
          };
          this.$api.reject(params).then(data => {
            this.resetEmployeesTable();
            this.$Message.info("您拒绝了申请");
          });
        },
        onCancel: () => {
          this.$Message.info("取消拒绝");
        }
      });
    },

    // 同意申请加入
    agreeJoinEnterprise(employeeInfo) {
      this.employee = this.$js.getObj(initEmployeeForm, employeeInfo);
      this.modifyEmployeeDrawerTitle = "同意加入申请并编辑人员信息";
      //组织人员和角色的初始人员
      this.employee.startOrganize = {
        organizationName: employeeInfo.departmentName,
        id: employeeInfo.departmentId
      };
      this.employee.startRoles = employeeInfo.roles
        ? employeeInfo.roles.map(item => {
            return {
              id: item.id,
              label: item.roleName
            };
          })
        : [];
      this.employee.type = "invite";
      this.modifyEmployeeDrawerStatus = true;
    },

    leaveCancel() {
      this.handlerClear();
      this.leaveModal = false;
    },

    // 离职
    leaveOffice(employeeInfo) {
      let roles = employeeInfo.roles || [];
      let isBoss = false;
      roles.forEach(role => {
        if ("boss" === role.roleName) {
          isBoss = true;
        }
      });
      if (isBoss) {
        let warningMessage =
          employeeInfo.employeeName +
          " 的角色是BOSS，不能直接离职，请让 " +
          employeeInfo.employeeName +
          " 转让BOSS角色后，再做离职操作";
        MessageBox.alert(warningMessage, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
        return;
      }
      this.leaveModal = true;
      this.leaveStatus.leverId = employeeInfo.id;
      if (employeeInfo.transferId) {
        this.leaveStatus.transferId = employeeInfo.transferId;
        this.leaveStatus.leaveTime = employeeInfo.leaveTime;
        this.defaultVal = [
          {
            type: 1,
            name: employeeInfo.transferName,
            id: employeeInfo.transferId
          }
        ];
      } else {
        this.defaultVal = [];
      }
    },

    modifyEmployee(val) {
      if (val.isAdd) {
        this.modifyEmployeeDrawerTitle = "添加人员";
        this.employee = JSON.parse(JSON.stringify(initEmployeeForm));
        this.employee.type = "add";
      } else {
        this.modifyEmployeeDrawerTitle = "编辑人员";
        this.employee = this.$js.getObj(initEmployeeForm, val.data);
        this.employee.rolesShow = "show";
        this.employee.id = val.data.id;
        this.employee.employeeSex = val.data.sexEnumItemId;
        //组织人员和角色的初始人员
        this.employee.startOrganize = val.data.departments.map(item => {
          return {
            organizationName: item.departmentName,
            id: item.id
          };
        });
        this.employee.startRoles = val.data.roles
          ? val.data.roles.map(item => {
              return {
                id: item.id,
                label: item.roleName
              };
            })
          : [];
        this.employee.type = "edit";
      }
      this.modifyEmployeeDrawerStatus = true;
    }
  }
};
</script>

<style>
</style>
